export enum Notifications_Type {
  // SOCKET= 1,
  PUSH = 2,
  // BROADCAST= 3,
  MAIL = 4,
}

export enum ROLE {
  ADMIN = 1,
  SUBADMIN = 2,
}
export enum DISCOUNT_TYPE {
  FLAT = 1,
  PERCENT = 2,
}

export enum APPROVAL_STATUS {
  PENDING = 0,
  APPROVED = 1,
  REJECTED = 2,
}

export enum CANCELLATION_STATUS {
  PENDING = 0,
  PENDING_PAYMENT = 1,
  CANCELLED = 2,
}

export enum UPDATE_TYPES {
  BLOCK = "block",
  ACCEPT = "accept",
  REJECT = "reject",
  ADD_TO_PREMIUM = "addToPremim",
}

export enum LOGIN_USER {
  APP_USER = "AppUser",
  SUB_ADMIN = "SubAdmin",
  ADMIN = "Admin",
  EMPLOYEE = "Employee",
}

export enum NOTIFICATION_TYPES {
  USER = "users",
  EMPLOYEE = "employee",
  SUB_ADMIN = "subadmin",
  ANDROID_USER = "android",
  IOS_USER = "ios",
  GROUPS = "Groups",
  OFFER = "offer",
  ALL = "all",
}

export enum OFFER_TYPE {
  RESTAURANT = "Restaurant",
  EVENTS = "Events",
  CONTACT_DEALERS = "Contact Dealers",
  OTHERS = "Others",
}

export enum OFFER_STATUS {
  ACTIVE = "activate",
  ARCHIVE = "archived",
}

export enum QUESTION_TYPE {
  CHECKBOX = "Checkbox",
  TEXT = "Text",
  RADIO = "Radio",
  TEXTAREA = "TextArea",
  DATE = "Date",
}

export enum BOOKING_STATUS {
  PENDING = "InProgress",
  NEW_BOOKING = "New",
  COMPLETE = "Completed",
  CONFIRM = "Confirmed",
  PENDING_CANCELLATION = "PendingCancellation",
  PENDING_PAYMENT = "PendingCancellationPayment",
  CANCELLED = "Cancelled",
}

export enum INTERNAL_STATUS {
  IN_PROGRESS = "In Progress",
  CONFIRMED = "Confirmed",
  NEW = "New",
  CANCELLED = "Cancelled",
  COMPLETED = "Completed",
}

export enum CANCEL_TYPE {
  REFUND = "Refund",
  COMPENSATION = "Compensation",
  CANCELLED = "Cancelled",
}

export enum MEMBERSHIP_TYPE {
  COMPLIMENTARY = "Complementary",
  TRAIL = "Trial",
}

export enum USER_TYPE {
  SINGLE = "Single",
  DUO = "Duo",
}

export enum NOTIFICATION_TYPE {
  ACCOUNT = "Account",
  BOOKING = "Booking",
  PAYMENT = "Payment",
  BROADCAST = "Broadcast",
}

export enum USER_STATUS {
  Pending = "Pending",
  Approved = "Approved",
  Rejected = "Rejected",
  Inactive = "Expired",
  Cancelled = "cancelsubscription",
  Expired = "Expired",
  All = "",
}

export enum BOOKING_SORTING {
  ClientDetail_asc = "ClientDetail_asc",
  ClientDetail_desc = "ClientDetail_desc",
  OfferName_asc = "OfferName_asc",
  OfferName_desc = "OfferName_desc",
  BookingTime_asc = "BookingTime_asc",
  BookingTime_desc = "BookingTime_desc",
  DateCreated_asc = "DateCreated_asc",
  DateCreated_desc = "DateCreated_desc",
  Category_asc = "Category_asc",
  Category_desc = "Category_desc",
  Status_asc = "Status_asc",
  Status_desc = "Status_desc",
}

export enum OFFER_SORTING {
  Title_asc = "Title_asc",
  Title_desc = "Title_desc",
  StartDate_asc = "StartDate_asc",
  StartDate_desc = "StartDate_desc",
  EndDate_asc = "EndDate_asc",
  EndDate_desc = "EndDate_desc",
}

export enum MEMBER_SORTING {
  Name_asc = "Name_asc",
  Name_desc = "Name_desc",
  DateCreated_asc = "DateCreated_asc",
  DateCreated_desc = "DateCreated_desc",
  MembershipType_asc = "MembershipType_asc",
  MembershipType_desc = "MembershipType_desc",
  Email_asc = "Email_asc",
  Email_desc = "Email_desc",
}

export enum CANCEL_SORTING {
  ClientDetail_asc = "ClientDetail_asc",
  ClientDetail_desc = "ClientDetail_desc",
  OfferName_asc = "OfferName_asc",
  OfferName_desc = "OfferName_desc",
  BookingTime_asc = "BookingTime_asc",
  BookingTime_desc = "BookingTime_desc",
  CancelledDate_asc = "CancelledDate_asc",
  CancelledDate_desc = "CancelledDate_desc",
  Category_asc = "Category_asc",
  Category_desc = "Category_desc",
  Status_asc = "Status_asc",
  Status_desc = "Status_desc",
}
